export const getContainerFactoryStyles = () =>
  ({
    visible: {
      height: '100%',
      width: '100%',
    },
    hidden: {
      height: '100%',
      width: '100%',
      display: 'none',
    },
  });
